import { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { KSelect } from '@/ui-library/components/molecules/KSelect';
import { SCHEDULE_AI_COPY } from '../../constants';
import { BulkCandidateTimezoneGroups } from './BulkCandidateTimezoneGroups';

const COPY = SCHEDULE_AI_COPY;

const FALLBACK_TIMING_OPTIONS = [
  { value: 'immediately', label: 'Now (Immediately)' },
];

export const TimingSection = ({
  timing,
  setTiming,
  setCustomSchedule,
  scheduleDisplayInCandidateTimezone,
  candidateCurrentTimeLine,
  hasCandidateTimezone,
  missingTimezoneMessage,
  customSchedulePastError,
  timingOptions = FALLBACK_TIMING_OPTIONS,
  onOpenCustomDateModal,
  bulkApplications,
}) => {
  const isBulk = Array.isArray(bulkApplications) && bulkApplications.length > 0;
  const timingSelectValue = useMemo(() => {
    const base = timingOptions.find((opt) => opt.value === timing);
    if (!base) return null;
    if (timing === 'custom' && scheduleDisplayInCandidateTimezone) {
      return {
        ...base,
        label: `${COPY.timingCustomDateSelectedPrefix} > ${scheduleDisplayInCandidateTimezone}`,
      };
    }
    return base;
  }, [timing, timingOptions, scheduleDisplayInCandidateTimezone]);

  return (
    <Box mb="20px">
      <KText variant="heading_4">{COPY.timingLabel}</KText>
      <Box mt="12px">
        <KSelect
          options={timingOptions}
          value={timingSelectValue}
          onChange={(opt) => {
            const val = opt?.value;
            setTiming(val);
            if (val !== 'custom') setCustomSchedule(null);
            if (val === 'custom' && onOpenCustomDateModal) {
              setTimeout(() => onOpenCustomDateModal(), 0);
            }
          }}
          placeholder="Select timing"
        />
        {isBulk ? (
          <BulkCandidateTimezoneGroups applications={bulkApplications} />
        ) : (
          hasCandidateTimezone &&
          candidateCurrentTimeLine && (
            <KText fontSize="13px" color="#6D659D" mt="8px">
              {candidateCurrentTimeLine}
            </KText>
          )
        )}
        {timing === 'custom' && customSchedulePastError && (
          <KText
            fontSize="13px"
            color="red.500"
            mt={candidateCurrentTimeLine ? '4px' : '8px'}
          >
            {COPY.customScheduleInPast}
          </KText>
        )}
        {!isBulk && !hasCandidateTimezone && (
          <KText fontSize="13px" color="#6D659D" mt="8px">
            {missingTimezoneMessage}
          </KText>
        )}
      </Box>
    </Box>
  );
};
